import { useState, useMemo } from 'react';
export function useForceRerender() {
  // @ts-ignore for unused variable, it's ok
  const [_, setRerenderCount] = useState(0);
  return useMemo(() => () => setRerenderCount((c) => c + 1), [
    setRerenderCount,
  ]);
}
